var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-form',[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('boton-captura')],1)],1),_c('v-layout',[_c('v-flex')],1),_c('v-layout')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }